const pillars = [
  {
    icon: 'ri-shield-check-line',
    title: 'Security First',
    desc: 'Every product we build is engineered with security at its core, protecting users from digital threats.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance',
    desc: 'Lightweight, fast, and battery-efficient — our apps are optimized for the best iOS experience.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'User Experience',
    desc: 'Clean interfaces and intuitive flows make our apps a pleasure to use every single day.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-[#F8F9FA] py-28 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <p className="text-xs uppercase tracking-[3px] text-[#9aa5b4] font-medium mb-4">Who We Are</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#1A2332] leading-tight max-w-lg">
              Expert Team Building<br />
              <span className="text-[#3d8b7a]">Secure Solutions</span>
            </h2>
            <p className="text-base text-[#666] leading-relaxed max-w-md">
              We are a dedicated group of iOS engineers, designers, and security specialists united by a single mission — making mobile devices safer and more efficient.
            </p>
          </div>
        </div>

        {/* Two-column layout */}
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {/* Left: image */}
          <div className="w-full lg:w-1/2">
            <div className="rounded-2xl overflow-hidden w-full h-[380px] md:h-[460px]">
              <img
                src="https://public.readdy.ai/ai/img_res/abde0f0d3360e8d834b79f3ee1ba4142.jpg"
                alt="BLANO DOO team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: pillars */}
          <div className="w-full lg:w-1/2 flex flex-col gap-8">
            <p className="text-base text-[#555] leading-relaxed">
              Founded with a passion for mobile technology, BLANO DOO brings together seasoned professionals who understand the iOS ecosystem inside and out. Our products, such as VPN and Cleaner, reflect our commitment to quality, privacy, and performance.
            </p>
            <p className="text-base text-[#555] leading-relaxed">
              We believe that every user deserves a secure and smooth mobile experience. That is why we invest heavily in research, testing, and continuous improvement of our applications.
            </p>

            <div className="flex flex-col gap-6 mt-2">
              {pillars.map((p) => (
                <div key={p.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#e8f4f1] text-[#3d8b7a] flex-shrink-0">
                    <i className={`${p.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A2332] text-sm mb-1">{p.title}</p>
                    <p className="text-sm text-[#777] leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
